import React from 'react';
import { number, arrayOf, func, string, bool } from 'prop-types';
import cx from 'classnames';

import trackingDeviceShape from 'propTypes/trackingDeviceShape';

import LocationTooltip from 'components/Map/MapComponents/LocationTooltip';
import locationIcon from './icons/location.svg';
import locationActiveIcon from './icons/location-active.svg';
import locationInactiveIcon from './icons/location-inactive.svg';
import warningIcon from './icons/location-warning.svg';
import warningActiveIcon from './icons/location-active-warning.svg';
import warningInactiveIcon from './icons/location-inactive-warning.svg';
import problemIcon from './icons/location-problem.svg';
import problemActiveIcon from './icons/location-active-problem.svg';

import styles from './LocationMarker.scss';

const icons = {
  ok: {
    default: locationIcon,
    active: locationActiveIcon,
    inactive: locationInactiveIcon,
  },
  warning: {
    default: warningIcon,
    active: warningActiveIcon,
    inactive: warningInactiveIcon,
  },
  disconnected: {
    default: problemIcon,
    active: problemActiveIcon,
    inactive: warningInactiveIcon,
  },
};

function getMarkerIcon(statusLabel, isActive, isFaded) {
  if (isActive) {
    return icons[statusLabel].active;
  }

  if (isFaded) {
    return icons[statusLabel].inactive;
  }

  return icons[statusLabel].default;
}

/* eslint-disable global-require */
function LocationMarker({
  trackingDevice,
  name,
  position,
  size,
  anchor,
  isActive,
  isFaded,
  onSelect,
  onEnter,
  onLeave,
}) {
  // eslint-disable-next-line global-require
  const { Marker } = require('react-leaflet');
  // eslint-disable-next-line global-require
  const { icon } = require('leaflet');

  const markerIcon = getMarkerIcon(trackingDevice.status, isActive, isFaded);

  const isCreate = location.pathname.includes('/create');

  return (
    <Marker
      position={position}
      icon={icon({
        iconUrl: markerIcon,
        iconSize: size,
        iconAnchor: anchor,
        className: cx({
          [styles.isFaded]: isCreate && isFaded,
        }),
      })}
      alt={`Location: ${name}, status: ${trackingDevice.status}`}
      keyboard
      riseOnHover
      interactive={!isCreate || !isFaded}
      onMouseover={onEnter}
      onMouseout={onLeave}
      onClick={onSelect}
    >
      <LocationTooltip trackingDevice={trackingDevice} locationName={name} />
    </Marker>
  );
}

LocationMarker.propTypes = {
  size: arrayOf(number),
  anchor: arrayOf(number),
  trackingDevice: trackingDeviceShape.isRequired,
  position: arrayOf(number).isRequired,
  name: string.isRequired,
  onSelect: func.isRequired,
  onEnter: func.isRequired,
  onLeave: func.isRequired,
  isActive: bool,
  isFaded: bool,
};

LocationMarker.defaultProps = {
  size: [20, 30], // [x, y]
  anchor: [10, 30], // [1/2 of size.x, 100% of size.y]
};

export default LocationMarker;



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/LocationMarker/index.js